import React from 'react';
var DialogContext = /*#__PURE__*/React.createContext(null);

var reducer = function reducer(state, action) {
  var type = action.type;

  switch (type) {
    default:
      return state;
  }
};

var DialogProvider = function DialogProvider(_a) {
  var children = _a.children,
      state = _a.state;

  var _b = React.useReducer(reducer, state),
      dialogState = _b[0],
      dispatch = _b[1];

  return /*#__PURE__*/React.createElement(DialogContext.Provider, {
    value: {
      dialogState: dialogState,
      dispatch: dispatch
    }
  }, children);
};

var DropdownMenuConsumer = DialogContext.Consumer;
export { DialogContext, DialogProvider, DropdownMenuConsumer };